import i18n from 'i18next'
/**
 * Selectable accents (design handoff 2026-09-14).
 *
 * Three values on two themes, all six contrast-verified. The accent is the
 * axis the deleted dim/forest/sepia themes were really reaching for — it
 * changes the five places colour is load-bearing (the filled control, the
 * selected tab, the focus ring, the saved dot, links) and nothing structural.
 */

export const ACCENT_NAMES = ['cerulean', 'plum', 'ink'] as const
export type AccentName = (typeof ACCENT_NAMES)[number]

export const DEFAULT_ACCENT: AccentName = 'cerulean'

// Getters: each read is in the interface's language.
export const ACCENT_LABELS: Record<AccentName, string> = {
    get cerulean() { return i18n.t('settings:appearance.accents.cerulean') },
    get plum() { return i18n.t('settings:appearance.accents.plum') },
    get ink() { return i18n.t('settings:appearance.accents.ink') },
}

export const ACCENT_BLURB: Record<AccentName, string> = {
    cerulean: 'The default blue',
    plum: 'Warmer, lower contrast',
    ink: 'Near-monochrome',
}

/** Swatch shown in the picker — the light-theme accent for each. */
export const ACCENT_SWATCH: Record<AccentName, string> = {
    cerulean: '#0A76A4',
    plum: '#7A3B62',
    ink: '#1C2B36',
}

export function normalizeAccent(name: unknown): AccentName {
    return (ACCENT_NAMES as readonly string[]).includes(name as string)
        ? (name as AccentName)
        : DEFAULT_ACCENT
}

/** Stamp the accent on <html>; styles/accents.css does the rest. */
export function applyAccent(name: AccentName): void {
    if (typeof document === 'undefined') return
    document.documentElement.setAttribute('data-accent', normalizeAccent(name))
}
